import { ItemListTable } from 'features/shop-item/components/item/list-table';
import { ShopItemFormFieldValue } from 'features/shop-item/components/shop-filter-form/type';
import { ItemListTopBar } from 'features/shop-item/components/top-bar/item-top-bar';
import { useGetItemList } from 'features/shop-item/use-cases/get-item';
import { usePaginationParams } from 'hooks';

const getInitialFilterValues: ShopItemFormFieldValue = {
  shop_category_id: undefined,
  is_active: undefined,
  name: undefined
};

export const ItemListView = () => {
  const { params, updateParams, resetPage } = usePaginationParams<any>({
    page: 1,
    size: 10,
    order_by: 'id',
    ...getInitialFilterValues,
  });

  const { data, refetch, isFetching } = useGetItemList(params);

  const handleFiltersChange = (values: any) => {
    updateParams(values);
    resetPage();
    refetch()
  };


  return (

    <>
      <ItemListTopBar
        handleFilter={handleFiltersChange}
        getInitialFilterValues={getInitialFilterValues}
        refetch={refetch}
      />

      <ItemListTable
        isSocialListLoading={isFetching}
        data={data}
        tableParams={params}
        updateParams={updateParams}
      // refetch={refetch}
      />
      {/* <Outlet /> */}
    </>
  );
};
